import { render, staticRenderFns } from "./ColumnEdit.vue?vue&type=template&id=7213ff75&scoped=true"
import script from "./ColumnEdit.vue?vue&type=script&lang=ts"
export * from "./ColumnEdit.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7213ff75",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7213ff75')) {
      api.createRecord('7213ff75', component.options)
    } else {
      api.reload('7213ff75', component.options)
    }
    module.hot.accept("./ColumnEdit.vue?vue&type=template&id=7213ff75&scoped=true", function () {
      api.rerender('7213ff75', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/mongoviews/ColumnEdit.vue"
export default component.exports